import React, {Component} from 'react';
import Dropzone from 'react-dropzone';
import TaggingField from './TaggingField';
import SearchField from './SearchField';
import i18n from "../../i18n";
import axios from 'axios';
import {isEmpty} from 'lodash';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from "@material-ui/core/Grid/Grid";
import _ from "lodash";
import PreviewButton from "../File/PreviewButton";
import Divider from "@material-ui/core/Divider";

const LineHeight = 40;

const styles = theme => ({
        preview: {
            maxHeight: 60,
            maxWidth: 80,
        },
        previewBox: {
            minHeight: 80,
        },
        fileicon: {
            height: 60,
            width: 80,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            color: theme.colors.lightGreyBlue,
        },
        fileiconIcon: {
            height: 50,
            width: 50,
            "background-size": "inherit",
        },
        fileiconExt: {
            textAlign: "center",
        },
        card: {
            flex: '1 0 auto',
            width: 80,
            position: 'relative',
            borderRadius: 4,
            border: `solid 1px ${theme.colors.paleGray}`,
            marginBottom: 20,
            // padding: "1.9rem",
            boxShadow: "inherit",
        },
        isPic: {},
        isNew: {},
        dropzone: {
            width: '100%',
            lineHeight: LineHeight + 'px',
            color: theme.colors.lightGreyBlue,
            backgroundColor: theme.colors.paleGray,
            cursor: 'pointer',
        },
        dropzoneIcon: {
            marginRight: theme.spacing.unit * 1.5,
            marginLeft: theme.spacing.unit * 1.5,
        },
        wrapIcon: {
            verticalAlign: 'middle',
            display: 'inline-flex',
        },


        buttons: {
            // flex: '1 0 auto',
            width: "100%",
            margin: "15px 0 0 0",
            "& button": {
                marginBottom: theme.spacing.unit * 1,
            }
        },
        vSpace: {
            marginTop: theme.spacing.unit * 4,
            marginBottom: theme.spacing.unit * 2,
        },
        iconSpace: {
            marginRight: theme.spacing.unit * 0.5,
            marginLeft: theme.spacing.unit * 0.5,
        },
    })
;

/**
 * https://react-dropzone.js.org/
 */
class MediaDropButton extends Component {

    constructor(props) {
        super();
        const uploadConfig = Object.assign({
            'urlUnlink': null,
            'urlLink': null,
            'urlSearch': null,
            'url': null,
            'urlTag': null,
            'files': [],
            'tab': 0,
        }, props.uploadConfig);

        if (props.onNewFile) {
            this.onNewFile = props.onNewFile;
        }

        this.state = {
            searchQuery: '',
            tab: uploadConfig.tab || 0,
            files: uploadConfig.files,
            uploadConfig: uploadConfig,
            searchedFiles: [],
        };
    }

    onNewFile = null;

    refreshFilesState(newfiles) {
        if (!newfiles) {
            newfiles = [];
        }
        this.setState({
            files: [].concat(newfiles, this.state.files),
        });
    }

    updateFileRelations(updatedfile) {
        let files = this.state.files;
        _.each(files, (file) => {
            if (file.iId === updatedfile.iId) {
                file.aRelations = updatedfile.aRelations;
            }
        });
        this.setState({
            files: files,
        });
    }

    doAutoLink(file) {
        if (!isEmpty(this.state.uploadConfig.urlLink)) { // darf automatisch linken
            axios.post(this.state.uploadConfig.urlLink, {'file_id': [file.sHash]})
                .then((response) => {
                    if (response.data && response.data.refs) {
                        file.aRelations = [].concat(response.data.refs, file.aRelations);
                    }
                    this.refreshFilesState();
                });
        }
    }

    onDrop(newfiles) {
        console.log(newfiles);

        const config = {headers: {'Content-Type': 'multipart/form-data'}};
        let fd = new FormData();

        console.log(fd);

        newfiles.map((file) => {
            fd.append('File[]', file);
        });

        console.log(fd);

        console.log(this.state.uploadConfig);

        axios.post(this.state.uploadConfig.url, fd, config)
            .then((response) => {
                newfiles.map((file, idx) => {
                    if (response.data && response.data.file_id && response.data.file_id.length > idx) {
                        try {
                            file.sHash = response.data.file_id[idx] || '';
                            file.icon = response.data.icons[idx] || '';
                            file.isImage = response.data.pics[idx] || '';
                            file.mcePic = response.data.mcePic[idx] || '';
                            file.sPrevPic = response.data.prevPic[idx] || '';
                            file.sTags = response.data.tags[idx] || '';
                            file.sExt = response.data.ext[idx] || '';
                            file.isNew = true;
                            file.isDeleted = false;

                            this.doAutoLink(file);
                            if (this.onNewFile) {
                                this.onNewFile(file);
                            }
                        } catch (ex) {
                            console.error(ex);
                        }
                    }
                });
                this.refreshFilesState(newfiles);
            })
            .catch(error => {
                console.error(error);
            })
    }

    renderPreview(file) {
        if (!file.icon) {
            file.icon = 'file-regular';
        }
        if (file && file.sPrevPic) {
            return (
                <Grid container
                      spacing={0}
                      className={this.props.classes.previewBox}
                      direction="row"
                      justify="center"
                      alignItems="center"
                >
                    <Grid item xs={12}>
                        <PreviewButton
                            file={file}
                            className={this.props.classes.preview}
                        />
                    </Grid>
                </Grid>
            );
        }
        return (
            <div className={this.props.classes.fileicon}>
                <CardMedia
                    className={this.props.classes.fileiconIcon}
                    image={"/images/filetype/" + file.icon + ".svg"}
                    title=""
                />
                <div className={this.props.classes.fileiconExt} color="primary">{file.sExt}</div>
            </div>
        );
    }

    renderFile(file) {
        if (file) {
            let classes = this.props.classes;
            let cardclasses = classes.card;
            cardclasses += (file.isDeleted ? ' ' + classes.isDeleted : '');
            cardclasses += (file.isImage ? ' ' + file.isPic : '');
            cardclasses += (file.isNew ? ' ' + classes.isNew : '');

            return (
                <Grid item xs={6} sm={3} md={2}
                      key={file.sHash || file.sName || file.filename || Math.random()}
                      className={cardclasses}
                >
                    {this.renderPreview(file)}
                </Grid>
            );
        }
        return null;
    }

    render() {
        return (
            <div className="dropZoneSection">
                <Typography variant="h6" className={this.props.classes.vSpace}>{i18n.get('file.attach')}</Typography>
                <Dropzone onDrop={this.onDrop.bind(this)} multiple={true} className={this.props.classes.dropzone}>
                    <Typography variant={"body1"} component={"span"} className={this.props.classes.wrapIcon}>
                        <Icon className={this.props.classes.dropzoneIcon}>cloud_upload</Icon>
                        {i18n.get('file.drop')}
                    </Typography>
                    {/*<Button size={"small"} variant="contained" color='primary'>{i18n.get('file.select')}</Button>*/}
                </Dropzone>
                <Grid container
                      spacing={8}
                      direction="row"
                      justify="center"
                      alignItems="center"
                >
                    {this.state.files && this.state.files.length > 0 && [].concat(this.state.files).sort((a, b) => {
                        if (a && b && a.iCreated === b.iCreated) {
                            return 0;
                        }
                        return (a && b && a.iCreated > b.iCreated ? -1 : 1);
                    }).map(f => (
                        this.renderFile(f)
                    ))}
                </Grid>
            </div>
        );
    }
}

MediaDropButton.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MediaDropButton);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Media/DropButton.js